export default "__VITE_ASSET__C2z4a_Ne__"